<eo-base-form-control
  [styleClass]="getStyleClass()"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [canBeNotApplicable]="canBeNotApplicable"
  [notApplicableLabel]="notApplicableLabel"
  [notApplicable]="notApplicable"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <p-editor [formControl]="getFormControl()" [style.height]="height" />
</eo-base-form-control>
